import fetch from "../axiosConfig";

//分页查询
export function diagnosisPage (data) {
  return fetch({
    url: "/diagnosis/page",
    method: "post",
    data: data,
  });
}
//修改
export function diagnosisUpdate (data) {
  return fetch({
    url: "/diagnosis/update",
    method: "post",
    data: data,
  });
}
//添加
export function diagnosisAdd (data) {
  return fetch({
    url: "/diagnosis/add",
    method: "post",
    data: data,
  });
}

//状态启用禁用
export function diagnosisUpStatus (data) {
  return fetch({
    url: "/diagnosis/updateStatus",
    method: "post",
    data: data,
  });
}

//文案配置管理

//文案配置管理列表
export function getGlobalInfoList (data) {
  return fetch({
    url: "sysGlobalInfo/getGlobalInfoList",
    method: "post",
    data,
  });
}

//修改
export function upGlobalInfo (data) {
  return fetch({
    url: "/sysGlobalInfo/upGlobalInfo",
    method: "post",
    data,
  });
}
//添加
export function addGlobalInfo (data) {
  return fetch({
    url: "/sysGlobalInfo/addGlobalInfo",
    method: "post",
    data,
  });
}
//查看详情
export function getGlobalInfoDetail (data) {
  return fetch({
    url: "/sysGlobalInfo/getGlobalInfoDetail",
    method: "post",
    data,
  });
}

//文案map
export function getGlobalInfoMap (data) {
  return fetch({
    url: "sysGlobalInfo/getGlobalInfoMap",
    method: "post",
    data,
  });
}


// WEBPACK FOOTER //
// ./src/api/system/configManage.js